module.exports = __webpack_public_path__ + "f84b29b8a9f3c22d8770fed326082dd5.png";


//////////////////
// WEBPACK FOOTER
// ../images/admin/campaign_analytics/icons/shares.png
// module id = 3315
// module chunks = 69